import FlCareApp from "./v2/App";

import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import CreateUser from "./pages/UserManagement/CreateUser";
import ProviderDashboard from "./pages/ProviderDashboard/ProviderDashboard";
import UserDashboard from "./pages/UserManagement/UserDashboard";
import FacilityRegistration from "./pages/FacilityManagement/FacilityRegistration";
import FacilityRegistrationSuccess from "./pages/FacilityManagement/FacilityRegistrationSuccess";
import FacilityUserReview from "./pages/FacilityManagement/FacilityUserReview";
import FacilityUserDashboard from "./pages/FacilityManagement/FacilityUserDashboard";
import RegistrationSuccessEmail from "./pages/FacilityManagement/RegistrationSuccessEmail";
import FacilityEdit from "./pages/FacilityManagement/FacilityEdit";
import ProtectedRoute from "./pages/ProtectedRoute";
import Unauthorized from "./pages/Auth/Unauthorized";
import NewComponent from "./pages/Dashboard/NewComponent";


export const FLCareLookupRoutes = () => {
	return (
		//order of routes matter here
		<Routes>				
				<Route element={<ProtectedRoute />}>	

				<Route path="/v2/*" element={<FlCareApp />} />

				<Route path="/" element={<Dashboard />} />			
				<Route path="*" element={<Navigate to="/dashboard" />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/about" element={<Dashboard />} />
				<Route path="/unauthorized" element={<Unauthorized />} />

				<Route path="/user/create" element={<CreateUser />} />
				<Route path="/ProviderDashboard" element={<ProviderDashboard />} />
				<Route path="/User/Dashboard" element={<UserDashboard />} />
				<Route path="/success" element={<FacilityRegistrationSuccess />} />
				<Route path="/HospitalRegistration/VerifyEmail" element={<RegistrationSuccessEmail />} />

			
				<Route path="/FacilityRegistration" element={<FacilityRegistration/>} /> 
				<Route path="/FacilityRegistration/:type/:Id" element={<FacilityRegistration/>} /> 
				<Route path="/Facility/Dashboard" element={<FacilityUserDashboard/>}/>
				<Route path="Facility/Review" element={<FacilityUserReview/>}/>
				<Route path="Facility/:hospitaltype/:hospitalId" element={<FacilityEdit/>}/>
			</Route>

			<Route path="/NewComponents" element={<NewComponent />} />

		</Routes>
	);
};


export default FLCareLookupRoutes;